import { Box, Button, HStack, Text, VStack } from '@chakra-ui/react';
import { FiPlus, FiFileText } from 'react-icons/fi'
import { useState } from 'react'
import { AskEditorCard } from './AskEditorCard'
import { AskTemplatePickerModal } from './AskTemplatePickerModal'
import { PacketDocumentsCard } from './attachments/PacketDocumentsCard'
import { useCreateAskFromTemplate } from '../../hooks/useLobbyDay'
import type { LobbyDayEventDetailDto } from '../../types/lobbyDay'

interface AsksTabProps {
  event: LobbyDayEventDetailDto
}

export function AsksTab({ event }: AsksTabProps) {
  const [isAdding, setAdding] = useState(false)
  const [pickerOpen, setPickerOpen] = useState(false)
  // When the draft card save-first-persists (Link bills / Save as template), the new ask arrives
  // via event.asks AND the draft card is still mounted -- rendering it twice. The draft card keeps
  // owning its just-created ask (so its bill modal stays open); we filter that id out here until
  // the draft card is done, then let it appear normally.
  const [draftAskId, setDraftAskId] = useState<string | undefined>()
  const createFromTemplate = useCreateAskFromTemplate(event.id)

  const finishAdding = () => {
    setAdding(false)
    setDraftAskId(undefined)
  }

  return (
    <Box>
      <Text color="gray.600" mb={4}>
        Talking points and bill content live on the ask — every meeting on that ask inherits them.
        Legislator backgrounds are edited on the legislator (Lobby Day → Legislators).
      </Text>
      <VStack align="stretch" gap={4}>
        {event.asks
          .filter((ask) => ask.id !== draftAskId)
          .map((ask) => (
            <AskEditorCard key={ask.id} eventId={event.id} ask={ask} />
          ))}
        {isAdding ? (
          <AskEditorCard eventId={event.id} onDone={finishAdding} onAskCreated={setDraftAskId} />
        ) : (
          <HStack gap={3}>
            <Button alignSelf="flex-start" size="sm" onClick={() => setAdding(true)}><FiPlus />Add ask
                        </Button>
            <Button alignSelf="flex-start" size="sm" variant="ghost" minH="44px" onClick={() => setPickerOpen(true)}>
              <FiFileText /> Add from template
            </Button>
          </HStack>
        )}
      </VStack>
      <PacketDocumentsCard event={event} />
      <AskTemplatePickerModal
        open={pickerOpen}
        onClose={() => setPickerOpen(false)}
        onUse={(id) => createFromTemplate.mutate(id, { onSuccess: () => setPickerOpen(false) })}
      />
    </Box>
  );
}
